import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles'
import { createTheme, ThemeProvider } from '@mui/material/styles';

import "./AdminSwitch.css"

//Tamanhos viaveis: sm, md, lg
export default function AdminSwitch({checked = undefined, onChange, size = 'sm', defaultChecked = undefined }) {

    const theme = createTheme({
        palette: {
          primary: {
            main: '#00925A', // Change this to your preferred primary color
          }
        },
        typography: {
          fontFamily: 'Mulish, sans-serif', // Change the default font family
          // You can also customize other typography properties here
        },
        // You can customize other aspects of the theme such as spacing, breakpoints, etc.
    });

    return (
        <ThemeProvider theme={theme}>
            <Switch 
              className={`admin-switch ${size}`} 
              defaultChecked={defaultChecked} checked={checked} 
              onChange={onChange} inputProps={{ 'aria-label': 'controlled' }}
            />
        </ThemeProvider>
    )
}